/// <reference path="../../../typings/globals/jquery/index.d.ts" />
/**
 * Vertical Image Slider
 * Mechanizm przesuwający obrazki w ramce (w jednej linii)
 * Sruktura: <div class="vis">img img img </div>
 *
 * Paramety mogą byc nadpisanę, przez atrybut data.
 * Przykład: data-random-order -> zostanie odczytany jako key: randomOrder
 *
 * @export
 * @class VerticalImageSlider
 */

 export class VerticalImageSlider {
	constructor (options) {
		let defaults = {
			testMode: false,
			selector: "vis",
			containerHeight: 100,
			boxClass: "visBox",
			paddingX: 15,
			efectsSpeed: 500,
			animationSpeed: 1000,
			animationInterval: 2000,
			randomOrder: true,
			initAnimation: function(){
				this.defaultAnimationMethod();
			}.bind(this),
			objSettings: Array()
		};
		this.settings = $.extend({}, defaults, options);

		this.settingsFromDataAttr = {};

		this.settings.visObjs = $("."+this.settings.selector);

		this.tmpCurrentAnimationVisIndex = null;

		let that = this;
		this.settings.visObjs.each( function(i,e){
			that.settings.objSettings.push({}); // inicjacja settings dla objektu
			that.prepareObjectBeforeImgLoad($(e), i);
		});
	}


	// ****************************************************************************************************
	// Przygotowanie obiektu przed inicjalizacją
	// ****************************************************************************************************
	prepareObjectBeforeImgLoad (visObj, visIndex) {
		let visObjSettings = this.settings.objSettings[visIndex];

		this.collectSettingsFromDataAttr(visObj);

		visObj.attr("id", this.settings.selector+""+visIndex);
		visObj.height(this.settings.containerHeight);

		if ( this.settings.randomOrder ) {
			this.randomizeElementsOrder(visObj);
		}

		//this.settings.visWidth = this.settings.visObjs.width(); // szerokość "netto" odejmuje padding
		visObjSettings.visWidth = visObj.width(); // szerokość "netto" odejmuje padding
		visObjSettings.elementsList = visObj.children("*"); // lista elementów w kontenerze
		visObjSettings.elementsCount =  visObjSettings.elementsList.length;
		visObjSettings.imagesList = visObj.find("img"); // lista zdjęć w kontenerze

		if ( visObjSettings.elementsCount > 0 ) {
			this.prepareObjectBeforeReady(visObj, visObjSettings, visIndex);

			visObjSettings.boxesList = visObj.children("."+this.settings.boxClass); // lista boxów w kontenerze

			this.prepareObjectAfterImgLoad(visObj, visObjSettings, visIndex);
		} else {
			console.error("Error - no image in container -> ", visObj.attr("id") );
			visObj.remove();
		}
	}

	// ****************************************************************************************************
	// Pobranie atrybutów data-
	// ****************************************************************************************************
	collectSettingsFromDataAttr (visObj) {
		let that = this;
		let dataAttr = visObj.data();
		let size = Object.keys(dataAttr).length;
		let archSize = Object.keys(this.settingsFromDataAttr).length;

		// przywrócenie nadpisanych ustawień z pola settings
		if ( archSize > 0 ) {
			$.each(this.settingsFromDataAttr, function(key, value){
				that.settings[key] = value;
			});
			this.settingsFromDataAttr = {};
		}

		// nadpisanie ustawien danymi z atrr data
		if ( size > 0 ) {
			$.each(dataAttr, function(key, value){
				if ( ( key in that.settings ) ) {
					that.settingsFromDataAttr[key] = that.settings[key];
					that.settings[key] = value;
				}
			});
		}
	}


	// ****************************************************************************************************
	// Losowa kolejność elementów
	// ****************************************************************************************************
	randomizeElementsOrder (visObj) {
		let oldOrder= visObj.children("*");
		let counter = oldOrder.length;
		let newOrder = new Array;
		let rand;

		while ( counter > 0 ) {
			rand = toolsObj.randomIntFromInterval(0, counter - 1);
			newOrder.push(oldOrder[rand]);
			oldOrder[rand].remove();

			oldOrder= visObj.children("*");
			counter--;
		}

		newOrder.forEach(function(e, i, arr){
			$(e).appendTo(visObj);
		});
	}


	// ****************************************************************************************************
	// ustawienie obiektu w tryb przez załadowaniem zdjęć
	// ****************************************************************************************************
	prepareObjectBeforeReady (visObj, visObjSettings, visIndex) {
		this.createImgContainers(visObj, visObjSettings, visIndex);

		visObjSettings.elementsList.css("opacity", 0);
	}


	// ****************************************************************************************************
	// Uporządkowanie/utworzenie struktury w kntenerze VIS
	// ****************************************************************************************************
	createImgContainers (visObj, visObjSettings, visIndex) {
		let that = this;

		visObjSettings.elementsList.each( function(i, e){
			$(e).attr("id", "visEl"+visIndex+"_"+i);
			$('<div id="'+that.settings.boxClass+visIndex+'_'+i+'" class="'+that.settings.boxClass+'">'+'</div>').appendTo(visObj).html($(e));
		});
	}


	// ****************************************************************************************************
	// wyznaczenie najszerszego zdjęcia i inicjalizacja modułu
	// (wymiary zdjęcia mozna pobrać dopiero po załadowaniu)
	// ****************************************************************************************************
	prepareObjectAfterImgLoad (visObj, visObjSettings, visIndex) {
		let that= this;
		let imgLoaded = 0;
		let totalImagesCount = visObjSettings.elementsCount;
		let maxWidth = 0;

		// czekanie na załadowanie się img
		visObjSettings.imagesList.each( function(i,e){
			$(e).attr("id", "imgVis_" + visIndex + "-" + i);

			if ( $(e)[0].complete ) { // img juz załadowany (chache)
				totalImagesCount--;

				maxWidth = that.setMaxWidth($(e), maxWidth);
			} else { // czekanie na załadowanie img
				 $(e).load(function() { // img załadowany
					imgLoaded++;

					maxWidth = that.setMaxWidth($(e), maxWidth);

					if ( imgLoaded >= totalImagesCount ) {
						that.allImagesLoadedCallback(visObj, visObjSettings, visIndex, maxWidth);
					}

				});
				$(e).error(function() { // blad ladowania IMG
					imgLoaded++;

					maxWidth = that.setMaxWidth($(e), maxWidth);

					if ( imgLoaded >= totalImagesCount ) {
						that.allImagesLoadedCallback(visObj, visObjSettings, visIndex, maxWidth);
					}

				});
			}

			// Wszystkie IMG załadowane z cache
			if ( totalImagesCount <= 0 ) {
				that.allImagesLoadedCallback(visObj, visObjSettings, visIndex, maxWidth);
			}
		});
	}


	// ****************************************************************************************************
	// Wyznaczenie max szerokośći IMG
	// ****************************************************************************************************
	setMaxWidth (obj, maxWidth) {
		if ( maxWidth < obj.width() ) {
			return obj.width();
		}
		return maxWidth;
	}


	// ****************************************************************************************************
	// Wsyztskie IMG załadowane
	// ****************************************************************************************************
	allImagesLoadedCallback (visObj, visObjSettings, visIndex, maxWidth) {
		let that= this;

		visObjSettings.maxImgWidth = ( visObjSettings.visWidth > maxWidth ) ? maxWidth : visObjSettings.visWidth;
		visObjSettings.boxWidth = visObjSettings.maxImgWidth + ( 2 * that.settings.paddingX );
		visObjSettings.pauseAnimation = false;

		that.init(visObj, visObjSettings, visIndex);
	}


	// ****************************************************************************************************
	// Inicjalizacja VerticalImageSlider
	// ****************************************************************************************************
	init (visObj, visObjSettings, visIndex) {
		this.setContainerWidth(visObj, visObjSettings);
		this.countVisibleElements(visObj, visObjSettings);
		this.setImgBoxParams(visObj, visObjSettings);

		this.prepareAnimation(visObj, visObjSettings, visIndex, 0);
	}


	// ****************************************************************************************************
	// obliczenie szerokości kontenera
	// ****************************************************************************************************
	setContainerWidth (visObj, visObjSettings) {
		let that = this;

		let sumBoxesWidth = visObjSettings.boxWidth * visObjSettings.elementsCount; // suma wszystkich szer. boxów
		let optimalContainerWidth = visObjSettings.visWidth - ( visObjSettings.visWidth % visObjSettings.boxWidth); // szerokość kontenera vis

		if ( sumBoxesWidth < optimalContainerWidth ) {
			visObjSettings.pauseAnimation = true;
			visObj.width( sumBoxesWidth );
		} else {
			visObjSettings.pauseAnimation = false;
			visObj.width( optimalContainerWidth );
		}

		visObjSettings.resizeTimeOut = null;
		$(window).on("resize", function(){
			clearTimeout(visObjSettings.resizeTimeOut);

			visObjSettings.resizeTimeOut = setTimeout(function(){
				visObj.width("auto");
				that.setContainerWidth(visObj, visObjSettings);
			}, RESIZE_CONTROL_DELAY);
		});
	}


	// ****************************************************************************************************
	// obliczenie sile jest widocznych boxów
	// ****************************************************************************************************
	countVisibleElements (visObj, visObjSettings) {
		visObjSettings.lastVisibleElementIndex = visObj.width() / visObjSettings.boxWidth - 1;
	}


	// ****************************************************************************************************
	// Przypisanie pozycji LEFT
	// ****************************************************************************************************
	setImgBoxParams (visObj, visObjSettings) {
		let that = this;

		visObjSettings.boxesList.each( function(i, e){
			let left = ( visObjSettings.boxWidth * i ) + "px";

			$(e).width(visObjSettings.boxWidth).css("left", left);
		});
	}


	// ****************************************************************************************************
	// wyświetlenie elementów slidera
	// ****************************************************************************************************
	prepareAnimation (visObj, visObjSettings, visIndex, index) {
		let that = this;
		let element = $(visObjSettings.elementsList[index]);
		let efectsSpeed = that.settings.efectsSpeed - ( that.settings.efectsSpeed * ( index * ( 1 / ( visObjSettings.lastVisibleElementIndex +1 ) ) ) ); // przyspieszenie animacji

		element.animate({
			opacity: 1
		}, efectsSpeed, function() {
			if ( index < visObjSettings.lastVisibleElementIndex ) {
				that.prepareAnimation(visObj, visObjSettings, visIndex, ++index );
			} else if ( index < visObjSettings.elementsCount ) {
				for (let i = index; i < visObjSettings.elementsCount; i++) {
					$(visObjSettings.elementsList[i]).css("opacity", 1);
				}

				that.tmpCurrentAnimationVisIndex = visIndex; // nie wiem jak to przekazać jako parametr call()
				that.settings.initAnimation.call();
			}
		});
	}

	// ****************************************************************************************************
	// domyślna funkcja animacji
	// ****************************************************************************************************
	defaultAnimationMethod () {
		let that = this;
		let visIndex = this.tmpCurrentAnimationVisIndex;
		this.tmpCurrentAnimationVisIndex = null;
		let visObjSettings = this.settings.objSettings[visIndex];

		visObjSettings.animationTimeout = setTimeout(function(){
			that.defaultAnimationStep(visObjSettings);
		}, this.settings.animationInterval);
	}


	// ****************************************************************************************************
	// krok animacji (domyslny)
	// ****************************************************************************************************
	defaultAnimationStep (visObjSettings){
		let that = this;
		let animationFactor = visObjSettings.pauseAnimation ? 0 : 1;
		let step = visObjSettings.boxWidth;

		visObjSettings.boxesList.each( function(i, e){
			let animateToLeft = Number( $(e).css("left").replace("px","") ) - ( step * animationFactor );

			$(e).animate({
				left: animateToLeft
			}, that.settings.animationSpeed, function() {
				if ( animateToLeft < 0 ) {
					$(e).css("left", step * ( visObjSettings.boxesList.length - 1 ) );
				}

				if ( i == visObjSettings.boxesList.length - 1 ) {
					visObjSettings.animationTimeout = setTimeout(function(){
						that.defaultAnimationStep(visObjSettings);
					}, that.settings.animationInterval);
				}
			});
		});
	}
}